import { contentStyles } from "modules/storyblok/adapters/Content";
import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";

const FeeModelCardContentStyles: RichtextAdapterProps["customStyles"] = {
  ...contentStyles,
  paragraph: { fontSize: "md" },
  list: {
    ...contentStyles.list,
    mt: 3,
    listStyleType: "disc",
    li: { mb: 2, ml: 8 },
    "li > p": { ml: 2 },
  },
};

const FeeModelCardSHeadingStyles: RichtextAdapterProps["customStyles"] = {
  ...contentStyles,
  heading: { textAlign: "center", mb: 2 },
};

export { FeeModelCardContentStyles, FeeModelCardSHeadingStyles };
